import * as ActionTypes from './ActionTypes'
import { Map } from 'immutable'

const getInitialState = () => {
  return Map({
    confirmPaymentDialog: false,
    confirmationDialog: Map({}),
    customerPaymentDialog: Map({}),
    customerViewingReceipt: Map({}),
    customerPayingWithCard: Map({}),
    transactionCompleteDialog: false,
    transactionErrorDialog: Map({}),
    customerEnteringTipDialog: Map({}),
    genericDialog: '',
    genericDialogOpen: false,
    genericDialogData: Map({}),
    cardAuthStepOne: Map({}),
    cardAuthStepTwo: Map({}),
    kitchenPrintErrorDialog: false,
    backbarFinalizeDialog: false,
    offlineDialog: Map({}),
    connectionRequiredDialog: Map({}),
    balanceLookupDialog: Map({}),
    printerNotConfiguredDialog: Map({}),
    openPriceRichCheckoutDialog: Map({}),
    priceAdjustExitConfirmation: Map({}),
    priceAdjustmentDialog: Map({}),
    syncWarningDialog: Map({}),
    cannotReopenTabDialog: Map({}),
    reopenTabDialog: Map({}),
    cannotReopenUnsyncedTabDialog: Map({}),
    mobileScanPaymentDialog: Map({}),
    CFDMessageReceiptErrorDialog: Map({}),
    CFDNotPairedDialog: Map({}),
    CFDBlockingDialog: Map({}),
    CFDPairedDialog: false,
    tipEntryModal: Map({}),
    taxDisplayDialog: Map({}),
    enteringInputDialog: Map({}),
    startATabModal: {},
    tabPaymentMethodModal: {},
    debugDialogOpen: false,
    transferTabModal: {},
    confirmDefaultTipModal: {},
    cashPaymentAlreadyAppliedModal: {},
    mobileQrReceipt: {},
  })
}

const reducer = (state = getInitialState(), action) => {
  switch (action.type) {
    case ActionTypes.VNDIALOGS_CONFIRM_PAYMENT_READY:
      return state.set('confirmPaymentDialog', action.dialog)
    case ActionTypes.VNDIALOGS_CONFIRMATION_DIALOG:
      return state.set('confirmationDialog', action.dialog)
    case ActionTypes.VNDIALOGS_CUSTOMER_PAYMENT:
      return state.set('customerPaymentDialog', Map(action.dialog))
    case ActionTypes.VNDIALOGS_CUSTOMER_VIEWING_RECEIPT:
      return state.set('customerViewingReceipt', Map(action.dialog))
    case ActionTypes.VNDIALOGS_CUSTOMER_PAYING_WITH_CARD:
      return state.set('customerPayingWithCard', Map(action.dialog))
    case ActionTypes.VNDIALOGS_TRANSACTION_COMPLETE:
      return state.set('transactionCompleteDialog', action.dialog)
    case ActionTypes.VNDIALOGS_TRANSACTION_ERROR:
      return state.set('transactionErrorDialog', Map(action.dialog))
    case ActionTypes.VNDIALOGS_CUSTOMER_ENTERING_TIP:
      return state.set('customerEnteringTipDialog', Map(action.dialog))
    case ActionTypes.VNDIALOGS_CARD_AUTH_STEP_ONE:
      return state.set('cardAuthStepOne', Map(action.dialog))
    case ActionTypes.VNDIALOGS_CARD_AUTH_STEP_TWO:
      return state.set('cardAuthStepTwo', Map(action.dialog))
    case ActionTypes.VNDIALOGS_KITCHEN_PRINTER_ERROR_DIALOG:
      return state.set('kitchenPrintErrorDialog', action.dialog)
    case ActionTypes.VNDIALOGS_BACK_BAR_FINALIZE_MODALS:
      return state.set('backbarFinalizeDialog', action.dialog)
    case ActionTypes.VNDIALOGS_OFFLINE_DIALOG:
      return state.set('offlineDialog', Map(action.dialog))
    case ActionTypes.VNDIALOGS_CONNECTION_REQUIRED_DIALOG:
      return state.set('connectionRequiredDialog', Map(action.dialog))
    case ActionTypes.VNDIALOGS_STOP_SYNC_DIALOG:
      return state.set('syncWarningDialog', Map(action.options))
    case ActionTypes.VNDIALOGS_BALANCE_LOOKUP:
      return state.set('balanceLookupDialog', Map(action.options))
    case ActionTypes.VNDIALOGS_PRINTER_NOT_CONFIGURED_DIALOG:
      return state.set('printerNotConfiguredDialog', Map(action.options))
    case ActionTypes.VNDIALOGS_OPEN_PRICE_RICH_CHECKOUT_NOT_SUPPORTED:
      return state.set('openPriceRichCheckoutDialog', Map(action.options))
    case ActionTypes.VNDIALOGS_PRICE_ADJUSTMENT_CONFIRM_EXIT:
      return state.set('priceAdjustExitConfirmation', Map(action.options))
    case ActionTypes.VNDIALOGS_PRICE_ADJUSTMENT_DIALOG:
      return state.set('priceAdjustmentDialog', Map(action.options))
    case ActionTypes.VNDIALOGS_CANNOT_REOPEN_TAB_DIALOG:
      return state.set('cannotReopenTabDialog', Map(action.options))
    case ActionTypes.VNDIALOGS_REOPEN_TAB_DIALOG:
      return state.set('reopenTabDialog', Map(action.options))
    case ActionTypes.VNDIALOGS_CANNOT_REOPEN_UNSYNCED_TAB:
      return state.set('cannotReopenUnsyncedTabDialog', Map(action.options))
    case ActionTypes.MOBILE_SCAN_PAYMENT_DIALOG:
      return state.set('mobileScanPaymentDialog', Map(action.data))
    case ActionTypes.VN_SET_MESSAGE_RECEIPT_ERROR_DIALOG:
      return state.set('CFDMessageReceiptErrorDialog', Map(action.options))
    case ActionTypes.VN_DIALOGS_CFD_NOT_PAIRED_DIALOG:
      return state.set('CFDNotPairedDialog', Map(action.options))
    case ActionTypes.VNDIALOGS_CFD_BLOCKING_DIALOG:
      return state.set('CFDBlockingDialog', Map(action.options))
    case ActionTypes.VNDIALOGS_CFD_PAIRED_DIALOG:
      return state.set('CFDPairedDialog', action.dialog)
    case ActionTypes.VNDIALOGS_VN_TIP_ENTRY_DIALOG:
      return state.set('tipEntryModal', Map(action.dialog))
    case ActionTypes.VNDIALOGS_TAX_DISPLAY_DIALOG:
      return state.set('taxDisplayDialog', Map(action.options))
    case ActionTypes.VN_ENTERING_INPUT_DIALOG:
      return state.set('enteringInputDialog', Map(action.dialog))
    case ActionTypes.VN_START_A_TAB_MODAL:
      return state.set('startATabModal', action.dialog)
    case ActionTypes.VN_TAB_PAYMENT_METHOD_MODAL:
      return state.set('tabPaymentMethodModal', action.dialog)
    case ActionTypes.VN_DEBUG_DIALOG:
      return state.set('debugDialogOpen', action.dialog)
    case ActionTypes.VN_TRANSFER_TAB_MODAL:
      return state.set('transferTabModal', action.dialog)
    case ActionTypes.CONFIRM_DEFAULT_TIP_MODAL:
      return state.set('confirmDefaultTipModal', action.dialog)
    case ActionTypes.VN_CASH_PAYMENT_ALREADY_APPLIED_MODAL:
      return state.set('cashPaymentAlreadyAppliedModal', action.options)
    case ActionTypes.VN_MOBILE_QR_RECEIPT_DIALOG:
      return state.set('mobileQrReceipt', action.dialog)
    default:
      return state
  }
}

export default reducer
